// Copyright (c) Docugami, Inc. All rights reserved.

import { ActionItem, AsyncActionStack } from "utils/AsyncActionStack";

export type PageDataWindow = [number, number];

export class PageDataDownloader {
    private readonly _actionStack: AsyncActionStack = new AsyncActionStack(2, 4);

    loadPage: (page: number) => Promise<void>;
    isLoaded: (page: number) => boolean;

    public constructor(
        loadPage: (page: number) => Promise<void>,
        isLoaded: (page: number) => boolean) {
        this.loadPage = loadPage;
        this.isLoaded = isLoaded;
    }

    public add(page: number, window?: PageDataWindow): void {
        const pages = [page];

        if (!!window) {
            let i = 1;
            while (i <= window[0] || i <= window[1]) {
                if (i <= window[1]) {
                    pages.push(page + i);
                }

                if (i <= window[0] && page - i > 0) {
                    pages.push(page - i)
                }

                ++i;
            }
        }

        this.addPages(pages);
    }

    private addPages(pages: number[]) {
        pages = pages.filter(x => !this.isLoaded(x));

        const actions: ActionItem[] = pages.map(x => {
            return {
                execute: () => this.loadPage(x),
                id: x.toString()
            }
        });

        this._actionStack.add(...actions);
    }
}
